function newDateTime(datetime) {
  try{
    const timeZone = 60 * 60 * 9 * 1000; // 9시간
    const now = new Date(datetime);
    const dateTime = new Date(+now + timeZone)
      .toISOString()
      .replace("T", " ")
      .replace(/\..*/, "");
  
    return dateTime;
  } catch (err) {
    console.log(err)
  }
  }

  export default newDateTime